import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { useEffect } from 'react';
import QueryParamsProxy from '../../../utils/queryParamProxy';
import RouteParamConstants from '../../../utils/routeParamConstants';
function useCheckHighlightedMessageId() {
  var highlightedMessageId = QueryParamsProxy.findParam(RouteParamConstants.PARAM_HIGHLIGHTED_MESSAGE_ID, false);
  useEffect(function () {
    return function () {
      return QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_HIGHLIGHTED_MESSAGE_ID, undefined));
    };
  }, []);
  return highlightedMessageId;
}
export default useCheckHighlightedMessageId;